<app-banner></app-banner>

<div class="container-fluid innerPageMenu">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>Gallery</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a routerLink="/gallery/photos"><i class="fa fa-angle-right" aria-hidden="true"></i>Photos</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/gallery/videos"><i class="fa fa-angle-right" aria-hidden="true"></i>Videos</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>